import { createStore,applyMiddleware } from 'redux'
import thunkMiddleware from "redux-thunk";
import logger from "redux-logger";
import AppReducer from './Reducer';


const store = createStore(AppReducer,
    applyMiddleware(thunkMiddleware, logger),
);
export default store